export default "__VITE_ASSET__CpfN7emA__"